import { render, staticRenderFns } from "./CampaignPicklHistory.vue?vue&type=template&id=b6531188&scoped=true&"
import script from "./CampaignPicklHistory.vue?vue&type=script&lang=ts&"
export * from "./CampaignPicklHistory.vue?vue&type=script&lang=ts&"
import style0 from "./CampaignPicklHistory.vue?vue&type=style&index=0&id=b6531188&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6531188",
  null
  
)

export default component.exports